import React, { Component } from "react";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
//import "ag-grid-community/dist/styles/ag-theme-material.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import {Text} from "@chakra-ui/react";

/*
const GRIDCOLSTATE = "gridcolstate";
const GRIDSORTMODE = "gridsortmode";
const GRIDFILTERMODE = "gridfiltermode";
*/

const divStyle = {
    width: "80%",
    height: '100%'
    //border: '5px solid black'
};

const columnDefs = [
    { headerName: "Item", field: "itemId", sortable: true, filter: true, resizable: true, minWidth: 100 },
    { headerName: "GTIN", field: "item.gtin", sortable: true, filter: true, resizable: true, minWidth: 100 },
    { headerName: "Quantity", field: "totalQty", sortable: true, filter: true, resizable: true, minWidth: 100 },
];



export default class DetailItemTable extends Component {
    constructor(props) {
        super(props);

        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onRowDataUpdated = this.onRowDataUpdated.bind(this);
    }

    onSelectionChanged() 
    {
        console.log("Changing selected row")
        var selectedNodes = this.gridApi.getSelectedNodes();
        var rowData = selectedNodes[0].data;
        // var rowNode = selectedNodes[0];
        console.info(rowData);
        this.props.selectedItemRowChange(rowData);
    }

    onRowDataUpdated()
    {
        // the problem we are trying to solve here is we would like to show the lot grid when we show the
        // item grid, but we have not yet selected and item!
        console.log("Row Data updated");
        if (this.props.selectedRow?.items)
        {
            this.props.selectedItemRowChange(this.props.selectedRow.items[0]);
        }
    }

 

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit(params)
    };

    render() {

        console.log("detailitemtable props: " + this.props.selectedRow)

        return (
            <div className="ag-theme-balham" style={divStyle}>
                <Text margin={0} fontSize={'24px'} color={'white'}>Item</Text>
                {(this.props.selectedRow) &&
                <AgGridReact
                    rowSelection="single"
                    enableRangeSelection={false}
                    // pagination={true}
                    columnDefs={columnDefs}
                    rowData={this.props.selectedRow?.items}
                    animateRows={true}
                    onGridReady={this.onGridReady}
                    onSelectionChanged={this.onSelectionChanged}
                    onRowDataUpdated={this.onRowDataUpdated}
                    gridOptions={this.gridOptions}
                    domLayout="autoHeight"
                    suppressHorizontalScroll={true}
                />
                }
            </div>
        );
    }
}